export default __webpack_public_path__ + "static/media/cinco.b0c67bdb.png";